<script setup lang="ts">
import { BusSaleQtyOption } from '~/apiClient';

const { tt } = useTypedI18n();

type Option = { label: string; value: BusSaleQtyOption };

const options: Option[] = [
    { label: tt('signup.fields.stats.unknown'), value: BusSaleQtyOption.unknown },
    { label: BusSaleQtyOption.NUMBER_0, value: BusSaleQtyOption.NUMBER_0 },
    { label: BusSaleQtyOption['1-2'], value: BusSaleQtyOption['1-2'] },
    { label: BusSaleQtyOption['2-5'], value: BusSaleQtyOption['2-5'] },
    { label: BusSaleQtyOption['5-10'], value: BusSaleQtyOption['5-10'] },
    { label: BusSaleQtyOption['10-20'], value: BusSaleQtyOption['10-20'] },
    { label: BusSaleQtyOption['>20'], value: BusSaleQtyOption['>20'] },
];

const model = defineModel<BusSaleQtyOption | undefined>();
</script>

<template>
    <USelectMenu v-model="model" :items="options" value-key="value" :search-input="false" />
</template>
